export const FUND_TYPE_OPTIONS = [
  { value: 'GRANT', label: 'Grant' },
  { value: 'SCHOLARSHIP', label: 'Scholarship' },
  { value: 'WORKSTUDY', label: 'WorkStudy' },
  { value: 'LOAN', label: 'Loan' },
  { value: 'EMPLOYEE', label: 'Employee' },
];

export const FUND_SOURCE_OPTIONS = [
  { value: 'INSTITUTIONAL', label: 'Institutional' },
  { value: 'FEDERAL', label: 'Federal' },
  { value: 'STATE', label: 'State' },
  { value: 'OUTSIDE', label: 'Outside' },
];

export const FUND_TYPE_LABELS = {
  GRANT: 'Grant',
  SCHOLARSHIP: 'Scholarship',
  WORKSTUDY: 'WorkStudy',
  LOAN: 'Loan',
  EMPLOYEE: 'Employee',
} as const satisfies Record<string, string>;

export type FundTypeLabelKey = keyof typeof FUND_TYPE_LABELS;

export const isFundTypeLabelKey = (value: string): value is FundTypeLabelKey =>
  value in FUND_TYPE_LABELS;

export const FUND_SOURCE_LABELS = {
  INSTITUTIONAL: 'Institutional',
  FEDERAL: 'Federal',
  STATE: 'State',
  OUTSIDE: 'Outside',
} as const satisfies Record<string, string>;

export type FundSourceLabelKey = keyof typeof FUND_SOURCE_LABELS;

export const isFundSourceLabelKey = (
  value: string
): value is FundSourceLabelKey => value in FUND_SOURCE_LABELS;

export const BOOL_FILTER_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
] as const;

export const DRAFT_STATUS = {
  CLEAN: 'clean',
  NEW: 'new',
  MODIFIED: 'modified',
  DELETED: 'deleted',
};

/**
 * `AWARDING_TYPE` dictionary codes that are Calculations-only (Special Awards) and must
 * not be offered as awarding logic for a special fund. `TOTAL_GIFT_AID` was added to the
 * shared dictionary for ADO #36688 / #37317; the backend resolves it to
 * `FundBucket.SKIPPED` on the funds path, so awarding it here always yields $0 (ADO #37526).
 */
export const FUNDS_EXCLUDED_AWARDING_TYPES: ReadonlySet<string> = new Set([
  'TOTAL_GIFT_AID',
]);
